import styled from 'styled-components';

import { TextArea as _TextArea } from '@sso/shared/core';

export const TextArea = styled(_TextArea)`
    textarea {
        white-space: pre;
    }
`;
